import Text from 'components/elements/text';
import { FullContainer, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

import ProductPurchaseOtherFeesTable from './other-fees-table';

export default function OtherFeesField() {
  const { t } = useTranslation();

  return (
    <FullContainer>
      <Text variant="ParagraphMedium">{t('common:other_fees')}</Text>
      <SeparatorVertical $margin={24} />
      <ProductPurchaseOtherFeesTable />
    </FullContainer>
  );
}
